type OpportunityReadRecord = Record<string, unknown>

function isRecord(value: unknown): value is OpportunityReadRecord {
	return value != null && typeof value === "object"
}

function coerceStringNumber(value: unknown): unknown {
	if (typeof value === "string") {
		return Number.parseFloat(value)
	}
	return value
}

function splitStringList(value: unknown, delimiter: string, fallback: string[] | null): string[] | null {
	if (typeof value === "string") {
		return value.split(delimiter).map(part => part.trim())
	}
	if (Array.isArray(value)) {
		return value.filter(part => part != null).map(part => String(part).trim())
	}
	return fallback
}

function splitNonEmptyStringList(value: unknown, delimiter: string, fallback: string[]): string[] {
	if (typeof value === "string" && value.length > 0) {
		return value
			.split(delimiter)
			.map(part => part.trim())
			.filter(Boolean)
	}
	if (Array.isArray(value)) {
		return value
			.filter(part => part != null)
			.map(part => String(part).trim())
			.filter(Boolean)
	}
	return fallback
}

function splitNumberList(value: unknown, delimiter: string): number[] | null {
	if (typeof value === "string") {
		return value.split(delimiter).map(Number).filter(Boolean)
	}
	if (Array.isArray(value)) {
		return value.map(Number).filter(Boolean)
	}
	return null
}

export function mapOpportunityRead(rawOpportunity: unknown): OpportunityReadRecord {
	if (!isRecord(rawOpportunity)) {
		return {}
	}

	const assetType = splitNonEmptyStringList(rawOpportunity.assetType ?? rawOpportunity.asset_type, ";", [])
	const landCategoryNew = splitNonEmptyStringList(
		rawOpportunity.landCategoryNew ?? rawOpportunity.land_category,
		";",
		[]
	)
	const landSubcategory = splitNonEmptyStringList(
		rawOpportunity.landSubcategory ?? rawOpportunity.land_sub_category,
		";",
		[]
	)

	return {
		...rawOpportunity,
		call_for_bids: Boolean(rawOpportunity.call_for_bids),
		latitude: coerceStringNumber(rawOpportunity.latitude),
		longitude: coerceStringNumber(rawOpportunity.longitude),
		lot_numbers_full: splitNumberList(rawOpportunity.lot_numbers_full, ";"),
		all_owners_ids: splitNumberList(rawOpportunity.all_owners_ids, ";"),
		all_owners_names: splitStringList(rawOpportunity.all_owners_names, ",", null),
		asset_type: splitNonEmptyStringList(rawOpportunity.asset_type, ";", []),
		land_category: splitNonEmptyStringList(rawOpportunity.land_category, ";", []),
		land_sub_category: splitNonEmptyStringList(rawOpportunity.land_sub_category, ";", []),
		assetType,
		landCategoryNew,
		landSubcategory,
	}
}
